import * as React from 'react';

import Spinner from '../../../../spinner/Spinner.jsx';

const SurveyStartSlidePlaceholder = () => (
  <div className="survey-start-slide-placeholder">
    <Spinner />
  </div>
);

export default SurveyStartSlidePlaceholder;
